import React from 'react'
import {
    Dialog,
    DialogContent,
    DialogTitle as MuiDialogTitle,
    IconButton,
    CircularProgress,
    Box
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import VariantView from '../VariantView'
import './VariantDetailsModal.scss'

export default function VariantDetailsModal({ open, onClose, variantId }) {
    if (!open || !variantId) {
        return null
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            className="variant-details-modal"
            PaperProps={{
                sx: {
                    minHeight: '80vh',
                    maxHeight: '90vh'
                }
            }}
        >
            <MuiDialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>Variantendetails: <code>{variantId}</code></span>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </MuiDialogTitle>
            <DialogContent dividers>
                <VariantView row={{ id: variantId }} />
            </DialogContent>
        </Dialog>
    )
}
